import { render, staticRenderFns } from "./Fel.vue?vue&type=template&id=c5407448"
import script from "./Fel.vue?vue&type=script&lang=js"
export * from "./Fel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports